import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendServiceService } from './backend-service.service';

@Injectable({
  providedIn: 'root'
})
export class ProductServiceService {

  trending_status= 'TRENDING';
  all_status = 'ALL';
  new_status = 'NEW';
  not_new_status = 'NotNew';
  old_status = 'OLD';
  popular_status = 'POPULAR';
 mirrorless_cameras = "Mirrorless";
 DSLR = "DSLR";

  constructor(private httpClient:HttpClient,private backendService:BackendServiceService) { }

  saveDetails(details:any){
    var token = localStorage.getItem('token');
    return this.httpClient.post<any>(this.backendService.apiLocalUrl+'system/admin/product/addproduct?mds='+token,details);
  }

  //Normal User
  getAllDetails(){
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'product/getallproduct');
   
  }

  //Normal User
  getProductDetailsById(itemId:any){
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'product/getproductdetilsbyid?id='+itemId);
  }

   getProductDetailsByKeywords(itemKeywords:any){
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'product/getproductdetilsbykeywords?itemKeywords='+itemKeywords);
  }

 

  getNewProducts(){
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'product/getnewproducts');
  }

  getNewProductsByStatus(status:any){
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'product/getproductsbystatus?status='+status);
  }

  getProductsForHomeBanner(){
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'product/getProductsForHomeBanner');
    
  }

  getProductsByType(type:any){
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'product/getproductsbytype?type='+type);
  }

  editImage(details:any){
    var token = localStorage.getItem('token');
    return this.httpClient.post<any>(this.backendService.apiLocalUrl+'system/admin/product/editproductimage?mds='+token,details);
  }

  editDetails(details:any){
    var token = localStorage.getItem('token');
    return this.httpClient.post<any>(this.backendService.apiLocalUrl+'system/admin/product/editproductdetails?mds='+token,details);
  }

  deleteProductByID(itemId:any){
    var token = localStorage.getItem('token');
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'system/admin/product/deleteitembyid?mds='+token+'&itemId='+itemId);
  }

  editStatusByAdmin(id:any,status:any){
    var token = localStorage.getItem('token');
    return this.httpClient.post<any>(this.backendService.apiLocalUrl+'system/admin/product/editproductstatus?mds='+token+'&status='+status+'&id='+id,status);
  }

  editHomeBannerByAdmin(id:any,homeBanneradded:boolean){
    var token = localStorage.getItem('token');
    return this.httpClient.post<any>(this.backendService.apiLocalUrl+'system/admin/product/editproductinhomebanner?mds='+token+'&inhomebanner='+homeBanneradded+'&id='+id,homeBanneradded);
  }
}
